import React from 'react';
import type { EventEnrollmentViewProps } from 'interfaces/enrollments/EventEnrollmentViewProps';

const parseMetadata = (json?: string): string => {
  if (!json) return '';
  try {
    const parsed = JSON.parse(json);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return json;
  }
};

export const EventEnrollmentView: React.FC<EventEnrollmentViewProps> = ({
  enrollment,
}) => {
  const metadata = parseMetadata(enrollment.metadataJson);

  return (
    <div className="p-4 border rounded bg-white shadow-sm space-y-3">
      <h3 className="text-lg font-semibold text-gray-800">{enrollment.eventName}</h3>

      {metadata && (
        <div>
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Details</p>
          <pre className="text-sm text-gray-700 bg-gray-50 border rounded p-3 overflow-auto whitespace-pre-wrap">
            {metadata}
          </pre>
        </div>
      )}

      <div className="flex items-center gap-2 text-sm text-yellow-700 bg-yellow-50 border border-yellow-200 rounded px-3 py-2">
        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Waiting for event to occur</span>
      </div>
    </div>
  );
};

export default EventEnrollmentView;
